import { movies } from "@/mocks/movies";
import { mustWatch } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function MustWatch() {
  const featured = mustWatch[0];
  const featuredMovie = movies.find((m) => m.id === featured.movieId);
  const rest = mustWatch.slice(1);

  return (
    <section id="must-watch" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="本周必看榜"
          title="五部值得优先安排的电影"
          description="综合口碑、完成度与观看体验排出的优先序列。如果最近只能看几部，从这里开始挑基本不会踩空。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[1.05fr_1fr]">
          {featuredMovie && (
            <article className="flex flex-col gap-5 rounded-lg border border-background-200 bg-background-50 p-5 md:flex-row md:p-6">
              <div className="relative h-[260px] w-full shrink-0 overflow-hidden rounded-md bg-background-100 md:h-auto md:w-[240px]">
                <img
                  src={featuredMovie.poster}
                  alt={`${featuredMovie.title} 电影海报`}
                  title={`${featuredMovie.title} 必看电影海报`}
                  className="h-full w-full object-top object-cover"
                />
                <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 font-label text-xs font-medium text-background-50">
                  <i className="ri-trophy-line text-xs"></i>
                  第 {featured.rank} 名
                </span>
              </div>
              <div className="flex flex-1 flex-col">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                    {featured.rank}
                  </span>
                  <div>
                    <h3 className="font-heading text-xl font-bold text-foreground-950">
                      {featuredMovie.title}
                    </h3>
                    <p className="font-label text-xs text-foreground-600">
                      {featuredMovie.genre} · {featuredMovie.year} · {featuredMovie.duration}
                    </p>
                  </div>
                </div>

                <p className="mt-4 text-sm leading-relaxed text-foreground-700">
                  {featuredMovie.description}
                </p>

                <div className="mt-4 flex flex-wrap gap-2">
                  {featuredMovie.highlights.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="flex items-center gap-1.5 font-heading text-2xl font-bold text-accent-600">
                    <i className="ri-star-fill text-lg"></i>
                    {featuredMovie.rating.toFixed(1)}
                  </span>
                  <span className="font-label text-xs text-foreground-500">
                    编辑推荐 · 优先观看
                  </span>
                </div>
              </div>
            </article>
          )}

          <ol className="flex flex-col gap-3">
            {rest.map((item) => {
              const movie = movies.find((m) => m.id === item.movieId);
              if (!movie) return null;
              return (
                <li
                  key={item.rank}
                  className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-100 font-heading text-base font-bold text-foreground-800">
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <h3 className="font-heading text-base font-semibold text-foreground-950">
                        {movie.title}
                      </h3>
                      <span className="flex items-center gap-1 font-label text-xs font-medium text-accent-600">
                        <i className="ri-star-fill text-[10px]"></i>
                        {movie.rating.toFixed(1)}
                      </span>
                      <span className="font-label text-xs text-foreground-500">
                        {movie.genre}
                      </span>
                    </div>
                    <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                      {item.review}
                    </p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}